import {Booking, BookingConfiguration, BookingState, CountBooking} from '../interfaces';



export const getters = {
  hasBookingConfig: (state: BookingState): boolean => !!state.bookingConfig,
  bookingConfig: (state: BookingState): BookingConfiguration | null => state.bookingConfig,
  error: (state: BookingState): boolean => state.error,
  loading: (state: BookingState): boolean => state.loading,
  response: (state: BookingState): boolean => state.response,
  errorMessage: (state: BookingState): string => state.errorMessage,
  countBookings: (state: BookingState): CountBooking[] => state.countBookings,
  currentBooking: (state: BookingState): Booking | null => state.currentBooking,
  bookingList: (state: BookingState): Booking[] | null => state.bookingList,
  minDate: (state: BookingState): string | null => state.minDate,
  maxDate: (state: BookingState): string | null => state.maxDate,
  step: (state: BookingState): number => state.step,
  noBookingPopUp: (state: BookingState): boolean => state.noBookingPopUp,
  notBookableDates: (state: BookingState): string[] | null => state.notBookableDates,
};
